import { PropsWithChildren } from "react";

const Action = ({
  children,
  text,
  onClick,
}: PropsWithChildren<{
  text: number | string;
  onClick?: () => void;
}>) => {
  return (
    <div className="flex items-center cursor-pointer" onClick={onClick}>
      {children}
      <div className="text-sm text-[#425460] ml-2">{text?.toString()}</div>
    </div>
  );
};

export default function ActionBtn({
  ...rest
}: PropsWithChildren<{
  text: number | string;
  onClick?: () => void;
}>) {
  return <Action {...rest} />;
}
